import { Box, Card, CardMedia, Typography } from "@mui/material";
import MarutiSuzuki from "assets/brand/marutiSuzuki.svg";
import MorrisGarages from "assets/brand/morrisGarages.svg";
// import Volkswagen from "assets/brand/volkswagen.png";
import Volkswagen from "assets/brand/volkswagen.svg";
import React from "react";

const Leaders = [
  { id: 1, name: "MarutiSuzuki", src: MarutiSuzuki },
  { id: 2, name: "Volkswagen", src: Volkswagen },
  { id: 3, name: "MorrisGarages", src: MorrisGarages },
];
export default function IndustryLeaders() {
  return (
    <Card
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "stretch",
        gap: { xs: "36px", sm: "36px", md: "24px" },
        padding: { xs: "20px 0px", sm: "20px 0px", md: "20px 12px" },
        boxShadow: "0px 8px 24px 0px rgba(78, 100, 122, 0.15)",
        borderRadius: "30px",
        backgroundColor: "#FEFFFF",
        alignContent: "center",
        marginTop: { xs: 0, sm: 0, md: 0, lg: 0, xl: "60px" },
      }}
    >
      <Typography
        sx={{
          color: "#555B5D",
          textAlign: "center",
          fontFamily: "Inter",
          fontWeight: 600,
          fontSize: { xs: "19px", sm: "23px", md: "23px" },
          lineHeight: 1.4,
        }}
      >
        Trusted by Industry Leaders
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", sm: "row", md: "row" },
          justifyContent: { xs: "center", sm: "center", md: "space-between" },
          alignItems: "center",
          alignSelf: "stretch",
          alignContent: "center",
          padding: { xs: "0px 64px", sm: "0px 64px", md: "0px" },
          gap: { xs: "36px 24px", sm: "12px 24px", md: "0px" },
          mixBlendMode: "luminosity",
        }}
      >
        {Leaders.map((item) => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CardMedia
              key={item.id}
              component="img"
              image={item.src}
              alt={item.name}
              sx={{
                background: "transparent",
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ))}
      </Box>
      <Typography
        sx={{
          color: "#555B5D",
          // textAlign: "end",
          fontFamily: "Inter",
          fontWeight: 600,
          fontSize: { xs: "15px", sm: "19px", md: "19px" },
          lineHeight: 1.4,
          marginRight: { xs: "24px", sm: "0px", md: "0px" },
          // width: "100%",
        }}
      >
        And More....
      </Typography>
    </Card>
  );
}
